import { __classPrivateFieldGet } from '../../node_modules/tslib/tslib.es6.js';
import { SDKResource } from '../../client/client.js';

// AUTOGENERATED -- DO NOT EDIT
var _Charge_instances, _Charge_baseUrlThunk;
class Charge extends SDKResource {
    constructor(config) {
        super(config);
        _Charge_instances.add(this);
    }
    /**
     * Charge patient's default payment method for a specified encounter or charge item.
     *
     * Access Policy Requirements:
     * Action: `Payment:Issue`
     * Access Policy Resource: `Payment:Charge`
     * Actions: `FHIR:Read,FHIR:Create,FHIR:Update`
     * Access Policy Resource: `FHIR:ChargeItem:*,`FHIR:PaymentReconciliation:*`
     * Action: `FHIR:Read`
     * Access Policy Resources: `FHIR:Patient:*,FHIR:Encounter:*,FHIR:Coverage:*`
     */
    issue(params, request) {
        return this.request('/payment/charge/issue', 'post', __classPrivateFieldGet(this, _Charge_instances, "m", _Charge_baseUrlThunk).bind(this))(params, request);
    }
    /**
     * Retrieve charge status for a specified encounter or charge item.
     *
     * Access Policy Requirements:
     * Action: `Payment:Status`
     * Access Policy Resource: `Payment:Charge`
     * Actions: `FHIR:Read,FHIR:Create,FHIR:Update`
     * Access Policy Resource: `FHIR:ChargeItem:*,`FHIR:PaymentReconciliation:*`
     * Action: `FHIR:Read`
     * Access Policy Resources: `FHIR:Patient:*,FHIR:Encounter:*,FHIR:Coverage:*`
     */
    status(params, request) {
        return this.request('/payment/charge/status', 'post', __classPrivateFieldGet(this, _Charge_instances, "m", _Charge_baseUrlThunk).bind(this))(params, request);
    }
}
_Charge_instances = new WeakSet(), _Charge_baseUrlThunk = function _Charge_baseUrlThunk() {
    var _a, _b;
    return (_b = (_a = this.config.services) === null || _a === void 0 ? void 0 : _a['projectApiUrl']) !== null && _b !== void 0 ? _b : 'https://project-api.zapehr.com/v1';
};

export { Charge };
//# sourceMappingURL=charge.js.map
